export const NOT_FOUND = "404";

// TODO: preklady - udelal bych v route aby renderovala title podobne jako label v gridu
export const PREHLED = "b2b.page-title.prehled";
export const PROVOZNI_INFORMACE = "b2b.page-title.provozni-informace";
export const PROVOZNI_INFORMACE_NOVA = "b2b.page-title.provozni-informace.nova";
export const PROVOZNI_INFORMACE_EDITACE =
  "b2b.page-title.provozni-informace.editace";
export const PROVOZNI_INFORMACE_DETAIL =
  "b2b.page-title.provozni-informace.detail";
export const REZERVACE = "b2b.page-title.rezervace";
export const REZERVACE_HISTORIE = "b2b.page-title.rezervace.historie";
export const REZERVACE_ODBAVENI = "b2b.page-title.rezervace.odbaveni";
export const REZERVACE_VYTVORENI = "b2b.page-title.rezervace.vytvoreni";
export const REZERVACE_CASOVY_PLAN = "b2b.page-title.rezervace.casovy-plan";
export const ADMINISTRACE = "b2b.page-title.administrace";
export const ADMINISTRACE_SMLOUVA = "b2b.page-title.administrace.smlouva";
export const ADMINISTRACE_PROJEKT = "b2b.page-title.administrace.projekt";
export const ADMINISTRACE_ZAKAZNICI = "b2b.page-title.administrace.zakaznici";
export const ADMINISTRACE_ZDROJE = "b2b.page-title.administrace.zdroje";
